const isDivider = (line) => /^[-_=*\s]{3,}$/.test(line.trim());
const isHeading = (line) => line.trim().startsWith("#") || /^\*\*[^*]+\*\*:?$/.test(line.trim());

const clean = (line) =>
  line
    .replace(/^#+\s*/, "")
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/^\s*[-*]\s+/, "• ")
    .trim();

export const BriefingText = ({ text, testId }) => (
  <div className="mt-4 space-y-2" data-testid={testId}>
    {text
      .split("\n")
      .filter((l) => l.trim() && !isDivider(l))
      .map((line, i) =>
        isHeading(line) ? (
          <p key={i} className="font-display text-sm font-semibold text-royal pt-2 first:pt-0">
            {clean(line)}
          </p>
        ) : (
          <p key={i} className="text-sm text-royal-deep leading-relaxed break-words">
            {clean(line)}
          </p>
        )
      )}
  </div>
);
